import { UilRefresh } from '@iconscout/react-unicons'
import { Box, Button, Flex, Typography } from 'components'
import { LayoutList } from 'containers/Layout'
import React from 'react'
import { Link } from 'react-router-dom'
import i18n from 'utils/i18n'

export const Fallback: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <LayoutList>
      <Box fullHeight>
        <Flex
          fullHeight
          directionColumn="zero"
          middle="zero"
          center="zero"
          gap={2}
          style={{
            position: 'relative',
            zIndex: 2,
          }}
        >
          <img src="/app/static/images/error_guy.svg" height="200" alt="error" />
          <img
            src="/app/static/images/checker.svg"
            height="700"
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: -1,
            }}
            alt="background"
          />
          <Flex directionColumn="zero" middle="zero" center="zero" gap={1.5}>
            <Flex directionColumn="zero" middle="zero" center="zero" gap={0.5}>
              <Flex directionColumn="zero" middle="zero" center="zero">
                <Typography color="grey900" fontSize="header_sm" fontWeight="bold">
                  {i18n.t('pages.common.fallback.trouble_text')}
                </Typography>
              </Flex>
              <Typography color="grey600" fontSize="text_xl">
                {i18n.t('pages.common.fallback.notified_text')}
              </Typography>
            </Flex>
            <Flex gap={0.5} middle="zero" center="zero">
              <Button
                onClick={() => window.location.reload()}
                variant="outline"
                color="secondary"
                iconLeft={UilRefresh}
              >
                {i18n.t('refresh')}
              </Button>
              <Link to="/" reloadDocument>
                <Button>{i18n.t('pages.common.error.go_to_homepage')}</Button>
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </LayoutList>
  )
}
